module.exports = __webpack_public_path__ + "img/nursing.dc76ac30.png";